export default __webpack_public_path__ + "static/media/P20_Micropipette.3b26a198.svg";